import type { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import type { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for backtracking a route (appending reversed markers/linestrings).
 * Stores the original counts + appended data for truncation on undo.
 */
export class BacktrackRouteCommand implements UndoCommand {
  readonly type = 'BACKTRACK_ROUTE';
  readonly routeKey: string;

  private originalMarkerCount: number;
  private originalLineStringCount: number;
  private addedMarkers: MarkerFeature[];
  private addedLineStrings: LineStringFeature[];

  constructor(data: {
    routeKey: string;
    originalMarkerCount: number;
    originalLineStringCount: number;
    addedMarkers: MarkerFeature[];
    addedLineStrings: LineStringFeature[];
  }) {
    this.routeKey = data.routeKey;
    this.originalMarkerCount = data.originalMarkerCount;
    this.originalLineStringCount = data.originalLineStringCount;
    this.addedMarkers = JSON.parse(JSON.stringify(data.addedMarkers));
    this.addedLineStrings = JSON.parse(JSON.stringify(data.addedLineStrings));
  }

  undo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    // Truncate back to original counts
    route.markers.splice(this.originalMarkerCount);
    route.lineStrings.splice(this.originalLineStringCount);
    route.updated_at = new Date();
  }

  redo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    // Re-append the backtracked data
    route.markers.push(...JSON.parse(JSON.stringify(this.addedMarkers)));
    route.lineStrings.push(...JSON.parse(JSON.stringify(this.addedLineStrings)));
    route.updated_at = new Date();
  }
}
